import { SVGProps } from "react";

export const DragAndDropIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="45"
    height="36"
    viewBox="0 0 45 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.125 33.75C4.53516 33.75 0 29.2148 0 23.625C0 19.2094 2.82656 15.4547 6.76406 14.0695C6.75703 13.8797 6.75 13.6898 6.75 13.5C6.75 7.28437 11.7844 2.25 18 2.25C22.1695 2.25 25.8047 4.51406 27.7523 7.88906C28.8211 7.17188 30.1148 6.75 31.5 6.75C35.2266 6.75 38.25 9.77344 38.25 13.5C38.25 14.3578 38.0883 15.1734 37.8 15.9328C41.9062 16.7625 45 20.3977 45 24.75C45 29.7211 40.9711 33.75 36 33.75H10.125ZM15.6797 18.4922C15.0188 19.1531 15.0188 20.2219 15.6797 20.8758C16.3406 21.5297 17.4094 21.5367 18.0633 20.8758L20.8055 18.1336V27.5625C20.8055 28.4977 21.5578 29.25 22.493 29.25C23.4281 29.25 24.1805 28.4977 24.1805 27.5625V18.1336L26.9227 20.8758C27.5836 21.5367 28.6523 21.5367 29.3062 20.8758C29.9602 20.2148 29.9672 19.1461 29.3062 18.4922L23.6812 12.8672C23.0203 12.2063 21.9516 12.2063 21.2977 12.8672L15.6727 18.4922H15.6797Z"
      fill="#489BA8"
    />
  </svg>
);

export const EditIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_466_6345)">
      <path
        d="M13.7812 1.84053L14.1594 2.21865C14.4531 2.5124 14.4531 2.9874 14.1594 3.27803L13.25 4.19053L11.8094 2.7499L12.7188 1.84053C13.0125 1.54678 13.4875 1.54678 13.7781 1.84053H13.7812ZM6.55625 8.00615L10.75 3.80928L12.1906 5.2499L7.99375 9.44365C7.90313 9.53428 7.79062 9.5999 7.66875 9.63428L5.84062 10.1562L6.3625 8.32803C6.39688 8.20615 6.4625 8.09365 6.55312 8.00303L6.55625 8.00615ZM11.6594 0.781152L5.49375 6.94365C5.22188 7.21553 5.025 7.5499 4.92188 7.91553L4.02812 11.0405C3.95312 11.303 4.025 11.5843 4.21875 11.778C4.4125 11.9718 4.69375 12.0437 4.95625 11.9687L8.08125 11.0749C8.45 10.9687 8.78438 10.7718 9.05313 10.503L15.2188 4.34053C16.0969 3.4624 16.0969 2.0374 15.2188 1.15928L14.8406 0.781152C13.9625 -0.0969726 12.5375 -0.0969726 11.6594 0.781152ZM2.75 1.9999C1.23125 1.9999 0 3.23115 0 4.7499V13.2499C0 14.7687 1.23125 15.9999 2.75 15.9999H11.25C12.7688 15.9999 14 14.7687 14 13.2499V9.7499C14 9.33428 13.6656 8.9999 13.25 8.9999C12.8344 8.9999 12.5 9.33428 12.5 9.7499V13.2499C12.5 13.9405 11.9406 14.4999 11.25 14.4999H2.75C2.05938 14.4999 1.5 13.9405 1.5 13.2499V4.7499C1.5 4.05928 2.05938 3.4999 2.75 3.4999H6.25C6.66563 3.4999 7 3.16553 7 2.7499C7 2.33428 6.66563 1.9999 6.25 1.9999H2.75Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_466_6345">
        <path d="M0 0H16V16H0V0Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PdfIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
  >
    <g clipPath="url(#clip0_466_6948)">
      <path
        d="M10 14.5C10.275 14.5 10.5 14.275 10.5 14V5H8C7.44688 5 7 4.55312 7 4V1.5H2C1.725 1.5 1.5 1.725 1.5 2V14C1.5 14.275 1.725 14.5 2 14.5H10ZM0 2C0 0.896875 0.896875 0 2 0H7.17188C7.70312 0 8.2125 0.209375 8.5875 0.584375L11.4156 3.4125C11.7906 3.7875 12 4.29688 12 4.82812V14C12 15.1031 11.1031 16 10 16H2C0.896875 16 0 15.1031 0 14V2Z"
        fill="#3B82F6"
      />
    </g>
    <defs>
      <clipPath id="clip0_466_6948">
        <path d="M0 0H12V16H0V0Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ImageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.00033 7.08366C5.00033 5.93307 5.93307 5.00033 7.08366 5.00033C8.23425 5.00033 9.16699 5.93307 9.16699 7.08366C9.16699 8.23425 8.23425 9.16699 7.08366 9.16699C5.93307 9.16699 5.00033 8.23425 5.00033 7.08366ZM7.08366 6.66699C6.85354 6.66699 6.66699 6.85354 6.66699 7.08366C6.66699 7.31378 6.85354 7.50033 7.08366 7.50033C7.31378 7.50033 7.50033 7.31378 7.50033 7.08366C7.50033 6.85354 7.31378 6.66699 7.08366 6.66699Z"
      fill="#489BA8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.66699 4.16699C1.66699 2.78628 2.78628 1.66699 4.16699 1.66699H15.8337C17.2144 1.66699 18.3337 2.78628 18.3337 4.16699V15.8337C18.3337 17.2144 17.2144 18.3337 15.8337 18.3337H4.16699C2.78628 18.3337 1.66699 17.2144 1.66699 15.8337V4.16699ZM4.16699 3.33366C3.70675 3.33366 3.33366 3.70675 3.33366 4.16699V15.8337C3.33366 16.191 3.5586 16.4958 3.87461 16.6143L12.7445 7.7444C13.0699 7.41897 13.5975 7.41897 13.923 7.7444L16.667 10.4884V4.16699C16.667 3.70675 16.2939 3.33366 15.8337 3.33366H4.16699ZM16.667 12.8454L13.3337 9.51217L6.1789 16.667H15.8337C16.2939 16.667 16.667 16.2939 16.667 15.8337V12.8454Z"
      fill="#489BA8"
    />
  </svg>
);
